import { fromBase64 } from "@renproject/utils";
import BigNumber from "bignumber.js";
export var PackPrimitive;
(function (PackPrimitive) {
    PackPrimitive["Bool"] = "bool";
    PackPrimitive["U8"] = "u8";
    PackPrimitive["U16"] = "u16";
    PackPrimitive["U32"] = "u32";
    PackPrimitive["U64"] = "u64";
    PackPrimitive["U128"] = "u128";
    PackPrimitive["U256"] = "u256";
    PackPrimitive["Str"] = "string";
    PackPrimitive["Bytes"] = "bytes";
    PackPrimitive["Bytes32"] = "bytes32";
    PackPrimitive["Bytes65"] = "bytes65";
})(PackPrimitive || (PackPrimitive = {}));
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const unmarshalPackPrimitive = (type, value) => {
    switch (type) {
        // Booleans
        case PackPrimitive.Bool:
            return value;
        // Integers
        case PackPrimitive.U8:
        case PackPrimitive.U16:
        case PackPrimitive.U32:
        case PackPrimitive.U64:
        case PackPrimitive.U128:
        case PackPrimitive.U256:
            return new BigNumber(value);
        // Strings
        case PackPrimitive.Str:
            return value;
        // Bytes
        case PackPrimitive.Bytes:
        case PackPrimitive.Bytes32:
        case PackPrimitive.Bytes65:
            return fromBase64(value);
    }
};
export const unmarshalPackStruct = (type, value) => {
    const struct = {};
    for (const member of type.struct) {
        const keys = Object.keys(member);
        if (keys.length === 0) {
            throw new Error(`Invalid struct member with no entries.`);
        }
        if (keys.length > 1) {
            throw new Error(`Invalid struct member with multiple entries.`);
        }
        const key = Object.keys(member)[0];
        const memberType = member[key];
        if (value && !value.hasOwnProperty(key)) {
            throw new Error(`Missing pack value for key ${key}.`);
        }
        struct[key] = unmarshalPackValue(memberType, value[key]);
    }
    return struct;
};
/**
 * Unmarshals a pack array.
 */
export const unmarshalPackArray = (type, value) => {
    return value.map((element) => unmarshalPackValue(type.list, element));
};
export const unmarshalPackValue = (type, value) => {
    if (Array.isArray(value)) {
        return unmarshalPackArray(type, value);
    }
    else if (typeof type === "object") {
        return unmarshalPackStruct(type, value);
    }
    else if (typeof type === "string") {
        if (type === "nil")
            return null;
        return unmarshalPackPrimitive(type, value);
    }
    throw new Error(`Unknown value type ${String(type)}${!type ? ` for value ${String(value)}` : ""}.`);
};
export const unmarshalTypedPackValue = ({ t, v }) => {
    return unmarshalPackValue(t, v);
};
//# sourceMappingURL=pack.js.map